/** Use the server-issued bearer URL in new notifications; preserve old templates when absent. */
export function reservationTicketEmail(content:string,ticketLink:string|null|undefined,label:string):string {
 if(!ticketLink)return content;
 let url:URL;try{url=new URL(ticketLink);}catch{return content;}
 if(!['https:','http:'].includes(url.protocol)||url.username||url.password||!/^#\/r\/[A-Za-z0-9_-]{24}$/.test(url.hash))return content;
 const escape=(v:string)=>v.replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]!));
 let inserted=false;
 return content.replace(/<a\b[^>]*href=["'][^"']*\/#\/(?:edit|edit-appointment|cancel)\/[^"']+["'][^>]*>[\s\S]*?<\/a>/gi,()=>{
  if(inserted)return '';inserted=true;
  return `<a href="${escape(url.toString())}" style="display:inline-block;padding:12px 24px;background:#1a3d8f;color:white;text-decoration:none;font-size:14px;font-weight:600;border-radius:24px;">${escape(label)}</a>`;
 });
}
